/**
 * Client for the med-dictate live-transcription benchmark backend endpoints.
 */

export function getApiBaseUrl() {
  return import.meta.env.VITE_TRANSCRIPTION_API_URL || "http://localhost:8000";
}

export function getWsBaseUrl() {
  return getApiBaseUrl().replace("http", "ws");
}

async function authedFetch(url, token, options = {}) {
  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }
  const response = await fetch(url, { ...options, headers });
  if (!response.ok) {
    const errorPayload = await response
      .json()
      .catch(() => ({ detail: response.statusText }));
    throw new Error(errorPayload.detail || `HTTP ${response.status}`);
  }
  return response;
}

export async function listBenchmarkDatasets(token) {
  const response = await authedFetch(
    `${getApiBaseUrl()}/v1/benchmark/datasets`,
    token,
  );
  const payload = await response.json();
  return payload.datasets || [];
}

export async function getDatasetSamples(token, datasetId) {
  const response = await authedFetch(
    `${getApiBaseUrl()}/v1/benchmark/datasets/${datasetId}/samples`,
    token,
  );
  const payload = await response.json();
  return payload.samples || [];
}

export async function fetchSampleAudioBlob(token, datasetId, sampleId) {
  const response = await authedFetch(
    `${getApiBaseUrl()}/v1/benchmark/datasets/${datasetId}/samples/${sampleId}/audio`,
    token,
  );
  return response.blob();
}
